export default __webpack_public_path__ + "28860def89fda69c4ddad399ec5dad68.png";